import $ from 'jquery';

const colors = {
  graphite: '#2F3134',
  'brushed-nickel': '#5F544F',
  'brushed-stainless': '#144B50',
  'polsihed-brass': '#AEA8A2',
  'polished-chrome': '#0E4483'
};

const gradient = document.createElement('div');
gradient.style.cssText = [
  'position: absolute',
  'z-index: 0',
  'left: 0',
  'top: 0',
  'width: 300%',
  'height: 100%',
  `background-color ${colors.graphite}`,
  'background-size: cover',
  'transition: all 0.75s'
].join(';');

const loadDetails = () => {
  const node = $('.special-finishes-details').get(0);
  const tabs = $('.finish-details-tabs');
  const sections = $('.finish-details')
    .get()
    .map((section, i) => {
      section.dataset.index = i;
      return section;
    });

  let currentSection = sections[0];
  node.insertBefore(gradient, node.firstElementChild);

  tabs.on('click', 'a', event => {
    event.preventDefault();

    const key = event.currentTarget.href.split('#')[1];
    const newSection = sections.find(el => el.dataset.key === key);
    if (newSection === currentSection) return;

    tabs.find('a').each((i, a) => {
      if (a.href.endsWith(key)) {
        a.classList.add('active');
      } else {
        a.classList.remove('active');
      }
    });

    requestAnimationFrame(() => {
      transition(currentSection, newSection);
    });
  });

  function transition(prev, next) {
    const nextColor = colors[next.dataset.key];
    gradient.style.backgroundColor = nextColor;
    prev.classList.remove('active');
    next.classList.add('active');
    currentSection = next;
  }
};

export default loadDetails;
